$('#tabPanelParametricSearch').toggleClass('tab-overflow');

if (navigator.userAgent.includes('Firefox')) {
    $('#tabPanelParametricSearch .search-box-general > ul').css('padding-right', '46px');
    $('.simplebar-track').css('right', '30px');
}